// components/toolbars/BlendToolbar.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Save, ArrowLeft, Award, CheckCircle } from 'lucide-react';

const BlendToolbar = ({ 
    onSave,
    onFinalize,
    averageAlcohol,
    isEditing,
    status = 'draft'  // Default to draft status
}) => {
    const navigate = useNavigate();
    const [showConfirmModal, setShowConfirmModal] = useState(false);

    const handleFinalize = () => {
        setShowConfirmModal(true);
    };

    const confirmFinalize = () => {
        setShowConfirmModal(false);
        onFinalize();
    };

    return (
        <div className="sticky-top bg-light border-bottom" style={{ top: '0', zIndex: 1020 }}>
            <div className="py-2">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <div className="btn-group">
                            <button 
                                className="btn btn-outline-secondary"
                                onClick={() => navigate('/blends')}
                                title="Back to List"
                            >
                                <ArrowLeft size={18} />
                            </button>
                            
                            {status !== 'finalized' && (
                                <button 
                                    className="btn btn-outline-primary"
                                    onClick={onSave}
                                    title="Save Blend"
                                >
                                    <Save size={18} />
                                </button>
                            )}
                        </div>
                        
                        {status === 'finalized' && (
                            <span className="badge bg-success ms-3">
                                <Award size={14} className="me-1" />
                                Finalized
                            </span>
                        )}
                    </div>
                    
                    <div className="d-flex align-items-center">
                        {status !== 'finalized' && (
                            <div className="me-3">
                                <span className="text-muted">
                                    Average Alcohol: {averageAlcohol || 'N/A'}%
                                </span>
                            </div>
                        )}
                        {status === 'finalized' && (
                            <div className="me-3">
                                <span className="text-muted">
                                    This blend has been finalized and created a new wine lot
                                </span>
                            </div>
                        )}
                        
                        {/* Finalize button moved to the right */}
                        {status !== 'finalized' && isEditing && (
                            <button 
                                className="btn btn-outline-success"
                                onClick={handleFinalize}
                                title="Finalize Blend"
                            >
                                <CheckCircle size={18} className="me-1" />
                                Finalize
                            </button>
                        )}
                    </div>
                </div>
            </div>
            
            {/* Confirmation Modal */}
            {showConfirmModal && (
                <div className="modal show d-block" tabIndex="-1">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirm Finalization</h5>
                                <button type="button" className="btn-close" onClick={() => setShowConfirmModal(false)}></button>
                            </div>
                            <div className="modal-body">
                                <p>Are you sure you want to finalize this blend? This will:</p>
                                <ul>
                                    <li>Create a new wine lot</li>
                                    <li>Move the selected barrels to the new wine lot</li>
                                    <li>Mark this blend as finalized (this cannot be undone)</li>
                                </ul>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowConfirmModal(false)}>Cancel</button>
                                <button type="button" className="btn btn-success" onClick={confirmFinalize}>Finalize Blend</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            
            <style jsx>{`
                .btn svg {
                    vertical-align: middle;
                    margin-top: -2px;
                }

                .btn:hover svg {
                    transform: scale(1.1);
                    transition: transform 0.2s ease;
                }

                .btn:active svg {
                    transform: scale(0.95);
                }
                
                .badge svg {
                    vertical-align: text-top;
                }
                
                .modal-backdrop {
                    opacity: 0.5;
                }
                
                .modal {
                    background-color: rgba(0,0,0,0.5);
                }
            `}</style>
        </div>
    );
};

export default BlendToolbar;